'use client';

import type { AuthSessionInfo } from '@/app/api/auth/_lib/types';
import EmbeddedAuth from '@/components/auth/embedded-auth';
import { useCheckout } from '../checkout-context';

function AuthenticatedCheckoutGate({ session }: { session: AuthSessionInfo }) {
  const { selectedPlan } = useCheckout();
  const planName = selectedPlan?.displayName || 'Penzu Pro';

  return (
    <div className="py-4 text-center">
      <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-green-100 text-2xl text-green-700">
        ✓
      </div>
      <h2 className="mb-2 font-merriweather text-2xl font-bold">Authentication complete</h2>
      <p className="mb-4 text-sm text-slate-600">Signed in as {session.user.email}.</p>
      <div className="rounded border border-amber-200 bg-amber-50 p-4 text-left text-sm text-amber-900">
        Purchasing {planName} with the modern session is not enabled yet. This dev preview
        intentionally stops here until Emerge&apos;s subscription endpoints accept bearer tokens.
      </div>
    </div>
  );
}

export default function ModernAuthStep() {
  const { state, handleModernAuthSuccess } = useCheckout();

  return (
    <EmbeddedAuth
      initialMode={state.authMode}
      returnTo="/checkout"
      onAuthenticated={handleModernAuthSuccess}
      renderAuthenticated={(session) => <AuthenticatedCheckoutGate session={session} />}
    />
  );
}
